import { Box, Typography } from '@mui/material';
import { labelTypographySx, sectionBarSx } from './printStyles';

interface SectionBarProps {
  title: string;
  centered?: boolean;
}

const SectionBar = ({ title, centered = false }: SectionBarProps) => (
  <Box
    sx={{
      ...sectionBarSx,
      flexShrink: 0,
      textAlign: centered ? 'center' : 'left',
    }}
  >
    <Typography sx={labelTypographySx}>{title}</Typography>
  </Box>
);

export default SectionBar;
